<template>
    <div
        role="main"
        tabindex="-1"
        class="ks-accessibility"
        :class="{'ks-accessibility-hover': hover}"
        @click="over"
        v-if="intro"
        :aria-pressed="$parent.accessActive ? 'true' : 'false'"
        :aria-label="$parent.accessActive ? 'Barrierfreier Zugang beenden' : 'Barrierefreier Zugang öffnen'"
    >
        <transition name="crossfade">
          <div class="ks-accessibility-container" :key="subpage._id" v-if="subpage">
            <router-link :to="{name: 'access'}">&larr; Zurück</router-link>
            <div id="ks-accessibility-header" @click.prevent="interaction($event)" v-html="subpage.Title"/>
            <div @click.prevent="interaction($event)" v-html="subpage.Text"/>
            <div class="downloads"  v-if="subpage.Downloads && subpage.Downloads.length > 0">
              <template v-for="dw in subpage.Downloads">
                <a class="item" :class="{'bigdownload-icon': !file.Resized}" v-for="(file, filekey) in dw.Download" target="_blank" :href="file.Original" v-bind:key="`download-${dw._id}-${filekey}`">
                  <div>
                    <img v-if="file.Resized" :src="file.Resized[1]"/>
                  </div>
                  <span v-html="file.Captions[0]"/>
                </a>
              </template>
            </div>
          </div>
          <div class="ks-accessibility-container" :key="intro._id" v-else>
            <div id="ks-accessibility-header" @click.prevent="interaction($event)" v-html="intro.Title"/>
            <div @click.prevent="interaction($event)" v-html="intro.Subtitle"/>
            <ul v-if="menu.length > 0">
              <li class="link" :key="m._id" v-for="m in menu">
                <router-link role="link" :aria-label="m._name" class="menu" :to="{name: 'access', params: {id: m._id, stub: m.stub}}" v-html="m.Title"/>
              </li>
            </ul>
            <div @click.prevent="interaction($event)" v-html="intro.Footer"/>
          </div>
        </transition>
    </div>
</template>

<script>

export default {
  name: 'Accessibility',
  data () {
    return {
      intro: null,
      menu: [],
      hover: false,
      subpage: null
    }
  },
  async mounted () {
    if (this.$route.params.id && this.$route.name === 'access') {
      await this.loadSubpage(this.$route.params.id)
    }
    this.$http(`/contributions/3/21?data=Title|Subtitle|Footer`).then((d) => {
      try {
        d.data.forEach(data => {
          if (data._template === 15) {
            this.intro = data || null
          } else {
            this.menu.push({...data, stub: this.createStub(data._name)})
          }
        })
      } catch (e) {
        this.intro = null
      }
    })
  },
  watch: {
    $route (to) {
      if (to.name === 'access') {
        if (to.params.id) {
          this.$root.baseNav = to
          this.loadSubpage(to.params.id)
        } else {
          this.subpage = null
        }
      }
    }
  },
  methods: {
    async loadSubpage (id) {
      try {
        this.subpage = (await this.$http(`/contribution/${+id}`)).data || {}
      } catch (err) {
        this.subpage = null
      }
      console.log(this.subpage)
    },
    createStub (str) {
      return str
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)+/g, '')
    },
    out () {
      this.hover = false
    },
    over () {
      this.$root.$emit('access-active', true)
    },
    interaction (e) {
      console.log(e)
      const t = e.target
      if (t.tagName === 'A') {
        if (t.origin === window.location.origin && t.pathname.startsWith('/')) {
          // this.$root.scrollOffset = true
          this.$router.push(t.pathname)
        } else {
          window.open(t.href, '_blank')
        }
      }
      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@import '../main';

.ks-accessibility {
  background: black;
  color: $ks-grey-medium;
  overflow: hidden;
  position: relative;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: var(--font-size);
  &-container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    left: 0px;
    top: 0px;
    position: absolute;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 1em;
    line-height: 1.25;
    .menu {
      p {
        margin: 0;
        padding: 0;
        border: none;
      }
    }
    .downloads {
      margin: 0;
      .item {
        margin: 0;
        display: flex;
        align-items: center;
        margin-bottom: 1rem;
        & > div {
          flex-basis: 6rem;
          margin: 0;
          padding: 0;
          img {
            width: auto;
            height: auto;
            max-height: 4rem;
            max-width: 6rem;
            object-fit: contain;
          }
        }
        & > span {
          flex-basis: calc(100% - 5rem);
          text-align: left;
          margin-left: 1rem;
          font: inherit
        }
      }
    }
    li {
        margin: 0;
        padding: 0;
        list-style: none;
        position: relative;
        transition: color 0.125s;
        &:before {
            content: "";
            background: $ks-grey-medium;
            border-radius: 50%;
            position: absolute;
            left: 0px;
            top: .25em;
            width: .75em;
            height: .75em;
            transform: translateX(-200%);
            transition: background 0.125s, transform 0.25s;
        }
    }
    ul {
        padding-left: 1.5em;
    }
    p, ul {
        border-bottom: 1px solid;
        padding-top: 0em;
        padding-bottom: 1em;
        margin-bottom: 1em;
        font: inherit;
    }
    a {
      color: $ks-blue;
      &:hover {
        text-decoration: underline;
      }
    }
    #ks-accessibility-header {
      p {
        padding-bottom: 0em;
        margin-bottom: 0em;
        border-bottom: none;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Accessibility.vue